import React, {Component} from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import ToolsWidget from "../../components/ToolsWidget/ToolsWidget";
import ContentTiles from "../../components/ContentTiles/ContentTiles";
import store from "../../store";
import {Helmet} from "react-helmet";

class SpecialtyShipments extends Component {
  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Learn" ? row.sections.map((section) => {
                          return section.title === "Specialty Shipments" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs
          pageTitle="Specialty Shipments"
        />
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/learn/page-components/text-block/specialty-shipments-heading.html"
        />
        <ContentTiles
          jsonDataUrl="./content/learn/page-components/article/specialty-shipments.json"
          pathForItem="/learn/specialty-shipments/specialty-shipment"
        />
        <div className="mb36">
          <ToolsWidget/>
        </div>
      </div>
    );
  }
}

export default SpecialtyShipments;



// WEBPACK FOOTER //
// ./src/pages/learn/SpecialtyShipments.js